<style scoped lang="scss">
.Withdrawal-content-div {
    height: 100vh;
    background-color: rgb(242 242 242) !important;
    
}



.pagination {
    margin: 1.5rem auto 0;
    width: fit-content;
}

.Withdrawal_data {
    min-height: 70vh;
}

.Withdrawal-header {
    font-weight: 550;
    cursor: pointer;
}

//移动端
@media screen and (max-width: 768px) {
    .Withdrawal_data-div {
        min-width: fit-content;
        margin-left: 1rem;
        width: fit-content;
        background-color: white;
        padding: 1rem;
        margin-top: 1rem;
    }

    .Withdrawal-content-div {
        min-width: fit-content;
    }
}

// pc端
@media screen and (min-width: 768px) {
    .Withdrawal_data-div {
        min-width: 90%;
        margin-left: 3rem;
        width: fit-content;
        background-color: white;
        padding-bottom: 1.5rem;
        margin-top: 1.5rem;
        
    .liu-text-success {
        color: #10b981;
        font-weight: 500;
        font-size: 0.95rem;
        letter-spacing: 0.01em;
        position: relative;
        padding-left: 1.25rem;

        &::before {
            content: '\2705';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .liu-text-danger {
        color: #ef4444;
        font-weight: 500;
        font-size: 0.95rem;
        letter-spacing: 0.01em;
        position: relative;
        padding-left: 1.25rem;

        &::before {
            content: '\274C';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    }

    .Withdrawal_data {
        min-width: 90%;
    }
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;height: 100vh;overflow: auto;padding-left: 0;background-color: rgb(242, 242, 242) !important;">
                    <div class="Withdrawal-content-div">
                        <div style="margin-bottom: 3rem;">
                            <div class="Withdrawal_data-div rounded shadow">
                                <div class="Withdrawal-header">
                                    <el-button type="success" class="addEmpower-btn  mt-4 mb-3 ml-5"
                                        @click="applyWithdrawal('dialog')">申请提现</el-button>
                                </div>
                                <el-table :data="Withdrawal_data" class="Withdrawal_data">
                                    <el-table-column prop="id" label="id" />
                                    <el-table-column prop="money" label="提现金额">
                                        <template #default="scope">
                                            <div :class="{'liu-text-danger':scope.row.state == -1,'liu-text-success': scope.row.state == 1}">
                                                {{ scope.row.money }}元
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column style="z-index: 9999;" prop="skm" label="收款码">
                                        <template v-slot="scope">
                                            <div style="z-index: 9999;" class="demo-image__preview">
                                                <el-image :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                                                    :src="scope.row.skm"
                                                    style="width: 100px; height: 100px;z-index: 9999;" />
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="act" label="提现方式">
                                        <template v-slot="scope">
                                            <div v-if="scope.row.act == 'wx'">微信</div>
                                            <div v-else-if="scope.row.act == 'zfb'">支付宝</div>
                                            <div v-else>未知</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="remarks" label="备注">
                                    </el-table-column>
                                    <el-table-column prop="state" label="状态">
                                        <template v-slot="scope">
                                            <div
                                                :class="{ 'liu-text-waring': scope.row.state == 0, 'liu-text-success': scope.row.state == 1, 'liu-text-danger': scope.row.state == -1 }">
                                                {{ getWithdrawalAct(scope.row.state) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="res_code" label="处理结果">
                                        <template v-slot="scope">
                                            <div v-if="!isNull(scope.row.res_code)">{{ scope.row.res_code }}</div>
                                            <div v-else>无</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="add_time" label="申请时间" />
                                    <el-table-column prop="end_time" label="处理时间">
                                        <template v-slot="scope">
                                            <div v-if="!isNull(scope.row.end_time)">{{ scope.row.end_time }}</div>
                                            <div v-else>无</div>
                                        </template>
                                    </el-table-column>

                                </el-table>
                                <el-pagination class="pagination" v-model:current-page="Withdrawal_Conf.currentPage"
                                    v-model:page-size="Withdrawal_Conf.pageSize" :page-sizes="[10, 25, 50]"
                                    :small="small" :disabled="disabled" :background="background"
                                    layout="total, sizes, prev, pager, next, jumper" :total="Withdrawal_Conf.total"
                                    @size-change="WithdrawalSizeChange" @current-change="WithdrawalCurrentChange" />
                            </div>
                        </div>
                    </div>
                    <el-dialog :close-on-click-modal="false" v-model="Withdrawal_Dialog.Visible" title="申请提现"
                        width="600">
                        <el-form :model="Withdrawal_Dialog.from" label-position="top">
                            <el-form-item label="提现金额">
                                <el-input type="number" :max="Withdrawal_Dialog.maxMoney"
                                    v-model="Withdrawal_Dialog.from.money" autocomplete="off" style="width: 6rem" />
                            </el-form-item>
                            <el-form-item label="选择收款方式">
                                <el-select v-model="Withdrawal_Dialog.from.selectAct" placeholder="--请选择--"
                                    style="width: 10rem">
                                    <el-option v-for="(item, i) in Withdrawal_Dialog.from.skAct" :key="i"
                                        :label="item.str" :value="item.act" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input rows="5" type="textarea" v-model="Withdrawal_Dialog.from.remarks"
                                    style="width: 30rem" autocomplete="off" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="Withdrawal_Dialog.Visible = false">关闭</el-button>
                                <el-button type="primary" @click="applyWithdrawal('apply')">申请提现</el-button>
                            </div>
                        </template>
                    </el-dialog>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isLogin, isNull } from "@/utils/publicMethods"
import { ElMessage, } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            Withdrawal_Conf: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            Withdrawal_data: [],
            Withdrawal_Dialog: {
                Visible: false,
                from: {
                    money: '',
                    skAct: [
                        { 'act': 'wx', 'skm': '', 'str': "微信" },
                        { 'act': 'zfb', 'skm': '', 'str': "支付宝" },
                    ],
                    selectAct: '',
                    remarks: ""
                },
                maxMoney: 0
            },
        }
    },
    methods: {
        getWithdrawalAct(act) {
            //    1:收入，2：支出，3：登录，4，其他
            switch (act) {
                case -1:
                    return "提现驳回"
                case 0:
                    return "等待审核"
                case 1:
                    return "已打款"
                default:
                    return "未知"
            }
        },
        getUserWithdrawal() {
            openLoading()
            const data = new FormData();
            data.append("page", this.Withdrawal_Conf.currentPage)
            data.append("pageSize", this.Withdrawal_Conf.pageSize)
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/userApi/getUserWithdrawal', data, { timeout: 30000, headers })
                .then(res => {
                    // isLogin(res)
                    if (res.data.code == 200) {
                        this.Withdrawal_data = res.data.data
                        this.Withdrawal_Conf.total = res.data.total
                        return
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getSkm() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/userApi/getSkm', data, { timeout: 30000, headers })
                .then(res => {
                    fullscreenLoading.close()
                    isLogin(res)
                    if (res.data.code == 200) {
                        this.Withdrawal_Dialog.from.skAct = res.data.data
                        this.Withdrawal_Dialog.maxMoney = res.data.money
                    }
                    else if (res.data.code == 401) {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    ElMessage.error(err)
                })
        },

        WithdrawalSizeChange(val) {
            this.Withdrawal_Conf.pageSize = val
            this.getUserWithdrawal()
        },
        WithdrawalCurrentChange(val) {
            this.Withdrawal_Conf.currentPage = val
            this.getUserWithdrawal()
        },
        applyWithdrawal(act) {
            console.log("11");
            if (act == 'dialog') {
                this.Withdrawal_Dialog.Visible = true
                this.getSkm()
            }
            else if (act == 'apply') {
                const data = new FormData();
                data.append("money", this.Withdrawal_Dialog.from.money)
                if (isNull(this.Withdrawal_Dialog.from.money)) {
                    ElMessage.error("请输入提现金额")
                    return
                }
                data.append("act", this.Withdrawal_Dialog.from.selectAct)
                let temp = this.Withdrawal_Dialog.from.skAct.filter(item => item.act == this.Withdrawal_Dialog.from.selectAct)
                if (temp.length == 0) {
                    ElMessage.error("请选择收款信息")
                    return
                }
                data.append("skm", temp[0].skm)
                data.append("remarks", this.Withdrawal_Dialog.from.remarks)
                const headers = {
                    'token': localStorage.getItem("token")
                }
                openLoading()
                axios.post(baseURL + '/userApi/applyWithdrawal', data, { timeout: 30000, headers })
                    .then(res => {
                        fullscreenLoading.close()
                        if (res.data.code == 401) {
                            ElMessage.error(res.data.msg)
                            setTimeout(() => {
                                location.href = "/login"
                            }, 1000);
                        } else if (res.data.code == 200) {
                            ElMessage.success(res.data.msg)
                            this.Withdrawal_Dialog.Visible = false
                            this.getUserWithdrawal()
                        } else {
                            ElMessage.error(res.data.msg)
                        }
                    })
                    .catch(err => {
                        fullscreenLoading.close()
                        ElMessage.error(err)
                    })
            }
        },
        isNull(text) {
            return isNull(text);
        }
    },
    mounted() {
        this.getUserWithdrawal()
    }
})
</script>
